(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vdrag", [], factory);
	else if(typeof exports === 'object')
		exports["vdrag"] = factory();
	else
		root["vdrag"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
	install: function install(Vue, options) {
		Vue.directive("drag", {
			bind: function bind(el, binding) {
				//console.log(binding)
				var position = "fixed";
				var zIndex = 4;
				var isChildDom;
				if (binding.value !== undefined) {
					if (binding.value.position) {
						position = binding.value.position;
					}
					if (binding.value.zIndex) {
						zIndex = binding.value.zIndex;
					}
					isChildDom = true;
				} else {
					isChildDom = false;
				}

				el.style.position = position;
				el.style.zIndex = zIndex;
				if (/Android|webOS|iPhone|BlackBerry/i.test(navigator.userAgent)) {

					//移动端
					var disX = 0;
					var disY = 0;
					el.addEventListener('touchstart', function (event) {

						//event.preventDefault();//阻止其他事件

						if (event.targetTouches.length == 1) {

							var touch = event.targetTouches[0]; // 把元素放在手指所在的位置

							disX = touch.pageX - el.offsetLeft; // 鼠标横坐标 - div1的left

							disY = touch.pageY - el.offsetTop; // 鼠标纵坐标 - div1的top
						}

						el.addEventListener('touchmove', function (event) {

							event.preventDefault();

							// 如果这个元素的位置内只有一个手指的话

							if (event.targetTouches.length == 1) {

								var touch = event.targetTouches[0]; // 把元素放在手指所在的位置

								var x = touch.pageX - disX;

								var y = touch.pageY - disY;

								var window_width = document.documentElement.clientWidth - el.offsetWidth;

								var window_height = document.documentElement.clientHeight - el.offsetHeight;

								x = x < 0 ? 0 : x; // 当div1到窗口最左边时

								x = x > window_width ? window_width : x; // 当div1到窗口最右边时

								y = y < 0 ? 0 : y; // 当div1到窗口最上边时

								y = y > window_height ? window_height : y; // 当div1到窗口最下边时


								el.style.left = x + "px";

								el.style.top = y + "px";
							}
						}, false);
					}, false);
				} else {
					var down = function down(e) {
						offsetX = e.pageX - el.offsetLeft;
						offsetY = e.pageY - el.offsetTop;
						if (isChildDom) {
							var childdom = el.querySelector(binding.value);
							childdom.style.position = "relative";

							if (binding.modifiers.cursor) childdom.style.cursor = "move";
							var barStyle = childdom.currentStyle ? childdom.currentStyle : window.getComputedStyle(childdom, null);
							var boxStyle = el.currentStyle ? el.currentStyle : window.getComputedStyle(el, null);
							var left = Number(barStyle.getPropertyValue("left").replace("px", "")) + Number(boxStyle.getPropertyValue("left").replace("px", "")) + Number(boxStyle.getPropertyValue("border-left-width").replace("px", ""));
							var right = left + Number(barStyle.getPropertyValue("width").replace("px", ""));
							var top = Number(barStyle.getPropertyValue("top").replace("px", "")) + Number(boxStyle.getPropertyValue("top").replace("px", "")) + Number(boxStyle.getPropertyValue("border-top-width").replace("px", ""));
							var bottom = top + Number(barStyle.getPropertyValue("height").replace("px", ""));
							// console.log(`left:${left}`)
							// console.log(`right:${right}`)
							// console.log(`top:${top}`)
							// console.log(`bottom:${bottom}`)
							// console.log(`clientX: ${e.clientX}`)
							// console.log(`clientY: ${e.clientY}`)
							if (e.clientX <= right && e.clientX >= left && e.clientY >= top && e.clientY <= bottom) {
								addEventListener("mousemove", move);
								addEventListener("mouseup", up);
							}
						} else {
							if (binding.modifiers.cursor) el.style.cursor = "move";
							addEventListener("mousemove", move);
							addEventListener("mouseup", up);
						}
					};

					var move = function move(e) {
						el.style.left = e.pageX - offsetX + "px";
						el.style.top = e.pageY - offsetY + "px";
					};

					var up = function up() {
						removeEventListener("mousemove", move);
						removeEventListener("mouseup", up);
					};

					//桌面端
					var offsetX = 0;
					var offsetY = 0;

					el.addEventListener("mousedown", down);
				}
			}
		});
	}
});

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// vdrag.js